import PropTypes from 'prop-types'
import React from 'react'
import SocialMediaIcon from '../SocialMediaIcon'
import { useRouter } from 'next/router'
import { APP_BASE_PATH } from '../../../common/constants'

const ShareIcons = ({ title, className }) => {
  const { asPath } = useRouter()
  const shareUrl = `${APP_BASE_PATH()}${asPath}`

  return (
    <div
      data-testid="share-icons"
      className={`flex justify-center ${className}`}
    >
      <SocialMediaIcon
        type="facebook"
        url={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          shareUrl
        )}`}
      />
      <SocialMediaIcon
        type="twitter"
        url={`https://twitter.com/share?text=${title}&url=${encodeURIComponent(
          shareUrl
        )}&via=freedomdebt`}
      />
      <SocialMediaIcon
        type="pinterest"
        url={`https://www.pinterest.com/pin/create/button/?url=${encodeURIComponent(
          shareUrl
        )}`}
      />
      <SocialMediaIcon
        type="linkedin"
        url={`https://www.linkedin.com/shareArticle?title=${title}&url=${encodeURIComponent(
          shareUrl
        )}&mini=true`}
      />
      <SocialMediaIcon
        type="email"
        url={`mailto:?subject=${title}&body=Check out this article on Freedom Debt Relief: ${shareUrl}`}
      />
    </div>
  )
}

ShareIcons.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  shareUrl: PropTypes.string,
}

ShareIcons.defaultProps = {
  className: '',
  title: '',
  shareUrl: '',
}

export default ShareIcons
